import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import sha256 from 'crypto-js/sha256'
import {message, notification} from "antd";


const FORM = [
    {
        name: "省",
        key: "province",
        type: "select",
    },
    {
        name: "市",
        key: "city",
        type: "select",
    },
    {
        name: "县",
        key: "county",
        type: "select",
    },
    {
        name: "上级登录名",
        key: "parentUsername",
        type: "input",
    },
    {
        name: "上级密码",
        key: "parentPassword",
        type: "password",
    },
    {
        name: "本级用户名",
        key: "username",
        type: "input",
        extra: "将初始化为安全管理员"
    },
    {
        name: "本级密码",
        key: "password",
        type: "password",
    },
]

const SystemInitPage = () => {
    const navigator = useNavigate()

    const [formData, setFormData] = useState({})
    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])
    const [counties, setCounties] = useState([])

    useEffect(() => {
        ApiService.common.region.root()
            .onSuccess(data => {
                setProvinces(data.map(i => {
                    return {name: i.name, value: i.code}
                }))
            })

    }, []);

    const handleFormChange = (change, all) => {
        const newFormData = {...all}
        if (change.hasOwnProperty('province')) {
            ApiService.common.region.children(change.province)
                .onSuccess(data => {
                    setCities(data.map(i => {
                        return {name: i.name, value: i.code}
                    }))
                })
            newFormData.city = null
            newFormData.county = null
        }
        if (change.hasOwnProperty('city')) {
            ApiService.common.region.children(change.city)
                .onSuccess(data => {
                    setCounties(data.map(i => {
                        return {name: i.name, value: i.code}
                    }))
                })
            newFormData.county = null
        }
        setFormData({...newFormData})
    }

    const handleFormSubmit = (event) => {
        if (!formData.parentPassword || formData.parentPassword.length === 0) {
            message.error("上级密码不能为空")
            return
        }
        if (!formData.password || formData.password.length === 0) {
            message.error("本级密码不能为空")
            return
        }
        if (!formData.parentUsername || formData.parentUsername.length === 0) {
            message.error("上级用户名不能为空")
            return
        }
        if (!formData.username || formData.username.length === 0) {
            message.error("本级用户名不能为空")
            return
        }
        const submitForm = {
            ...formData,
            parentPassword: sha256(formData.parentPassword).toString(),
            password: sha256(formData.password).toString()
        }
        ApiService.user.init(submitForm)
            .onSuccess(() => {
                notification.success({
                    message: "已完成本节点安全管理员初始化",
                    description: "请使用本节点安全管理员登录平台，随后进行用户分配以及权限管理。"
                })
                navigator('/login', {replace: true})
            })
    }

    return (
        <>
            <AutoFormCard
                title={"系统初始化"}
                formStruct={FORM}
                initValues={formData}
                selectOptions={{
                    province: provinces,
                    city: cities,
                    county: counties,
                }}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
            />
        </>
    )
}

export default SystemInitPage